import type { ReactNode } from "react";
import { Provider as ReduxProvider } from "react-redux";
import { I18nextProvider } from "react-i18next";
import { store } from "./store";
import { i18n } from "@/shared/i18n";
import { ToastProvider } from "@/shared/ui";

export function Providers({ children }: { children: ReactNode }) {
  return (
    <ReduxProvider store={store}>
      <I18nextProvider i18n={i18n}>
        <ToastProvider>{children}</ToastProvider>
      </I18nextProvider>
    </ReduxProvider>
  );
}
